import {Button, Modal, Typography} from '@yandex-delivery/blocks'
import React from 'react'
import type {BaseWindowSettings} from 'src/api/types'

type Props = {
  window: BaseWindowSettings
  opened: boolean
  onClose: VoidFunction
  onConfirm: VoidFunction
}

export function ExtendExpirationModal(props: Props): React.ReactElement {
  const {window, opened, onClose, onConfirm} = props

  return (
    <Modal mx="m" onClose={onClose} opened={opened}>
      <Modal.Header
        title={
          // Заголовок бывает длинным и в дефолтном title4 (24px) налезал на
          // крестик — рендерим на размер меньше (body1, 20px). CARGODEV-86994.
          <Typography thickness="medium" variant="body1">
            {window.title}
          </Typography>
        }
      />
      {window.subtitle && <Modal.Body>{window.subtitle}</Modal.Body>}
      <Modal.Footer>
        <Modal.Footer.Controls>
          {window.cancel_button_title && (
            <Button onPress={onClose} size="l" variant="default">
              {window.cancel_button_title}
            </Button>
          )}
          <Button onPress={onConfirm} size="l" variant="action">
            {window.done_button_title}
          </Button>
        </Modal.Footer.Controls>
      </Modal.Footer>
    </Modal>
  )
}
